import ViewController from "core/views/view.controller";

export default class SplitViewCtrl extends ViewController {
    static $inject = ['$rootScope', '$scope', '$window', '$ionicScrollDelegate', 'screenSize'];

    constructor() {
        super(...arguments);

        if (this._viewLeftOpen == null) {
            this._viewLeftOpenSource = true;
            this._viewLeftOpen = true;
        }

        if (this._viewRightOpen == null) {
            this._viewRightOpenSource = true;
            this._viewRightOpen = true;
        }

        this.onResize = null;
    }

    $onInit() {
        this.viewLeftOpen = this.viewLeftOpenSource;
        this.viewRightOpen = this.viewRightOpenSource;

        this.screenSize.on('xs,sm,md,lg', ()=> {
            this.viewLeftOpen = this.viewLeftOpenSource;
            this.viewRightOpen = this.viewRightOpenSource;
        });
    }

    set viewLeftOpen(open) {
        this.viewLeftOpenSource = open;

        if (this.screenSize) {
            this._viewLeftOpen = this.parseViewOpenValue(open);
        }
    }

    get viewLeftOpen() {
        return this._viewLeftOpen;
    }

    set viewRightOpen(open) {
        this.viewRightOpenSource = open;

        if (this.screenSize) {
            this._viewRightOpen = this.parseViewOpenValue(open);
        }
    }

    get viewRightOpen() {
        return this._viewRightOpen;
    }

    parseViewOpenValue(open) {
        if (open == null) {
            return false;
        }

        if (open == true || open == false) {
            return open;
        }

        open = this.screenSize.is(open);
        return open;
    }

}



// WEBPACK FOOTER //
// ./src/modules/core/components/split-view/split-view.controller.js